import AnswerWinServices from '@/services-ts/Common/AnswerWinServices'
import BlacklistServices from '@/services-ts/Common/BlacklistServices'
import { ChallengeServices } from '@/services-ts/Common/ChallengeServices'
import CommonServices from '@/services-ts/Common/CommonServices'
import FileServices from '@/services-ts/Common/FileServices'
import FilterServices from '@/services-ts/Common/FilterServices'
import HekateServices from '@/services-ts/Common/HekateServices'
import MenuServices from '@/services-ts/Common/MenuServices'
import PopupNotificationServices from '@/services-ts/Common/PopupNotificationServices'
import QuoteServices from '@/services-ts/Common/QuoteServices'
import ResourceServices from '@/services-ts/Common/ResourceServices'
import SurveyServices from '@/services-ts/Common/SurveyServices'
import WordGameService from '@/services-ts/Common/WordGameService'

const CommonAPI = (apiCommon: string) => {
  return {
    CommonServices: new CommonServices(apiCommon),
    AnswerWinServices: new AnswerWinServices(apiCommon),
    ResourceServices: new ResourceServices(apiCommon),
    MenuServices: new MenuServices(apiCommon),
    QuoteServices: new QuoteServices(apiCommon),
    FilterServices: new FilterServices(apiCommon),
    BlacklistServices: new BlacklistServices(apiCommon),
    FileServices: new FileServices(apiCommon),
    SurveyServices: new SurveyServices(apiCommon),
    HekateServices: new HekateServices(apiCommon),
    ChallengeServices: new ChallengeServices(apiCommon),
    WordGameService: new WordGameService(apiCommon),
    PopupNotificationServices: new PopupNotificationServices(apiCommon),
  }
}

export default CommonAPI
